import { j as H } from "../jsx-runtime-Wav_3Wde.js";
import E, { useState as V, useEffect as G } from "react";
import { a as P, b as J, c as k } from "../inheritsLoose-BuSn_CvZ.js";
import { g as B } from "../_commonjsHelpers-DjF3Plf2.js";
import Y from "react-is";
function D(r, a) {
  if (r == null) return {};
  var n = {};
  for (var i in r) if ({}.hasOwnProperty.call(r, i)) {
    if (a.indexOf(i) !== -1) continue;
    n[i] = r[i];
  }
  return n;
}
var x, j;
function Q() {
  if (j) return x;
  j = 1;
  var r = Y, a = {
    childContextTypes: !0,
    contextType: !0,
    contextTypes: !0,
    defaultProps: !0,
    displayName: !0,
    getDefaultProps: !0,
    getDerivedStateFromError: !0,
    getDerivedStateFromProps: !0,
    mixins: !0,
    propTypes: !0,
    type: !0
  }, n = {
    name: !0,
    length: !0,
    prototype: !0,
    caller: !0,
    callee: !0,
    arguments: !0,
    arity: !0
  }, i = {
    $$typeof: !0,
    render: !0,
    defaultProps: !0,
    displayName: !0,
    propTypes: !0
  }, h = {
    $$typeof: !0,
    compare: !0,
    defaultProps: !0,
    displayName: !0,
    propTypes: !0,
    type: !0
  }, v = {};
  v[r.ForwardRef] = i, v[r.Memo] = h;
  function m(y) {
    return r.isMemo(y) ? h : v[y.$$typeof] || a;
  }
  var _ = Object.defineProperty, f = Object.getOwnPropertyNames, s = Object.getOwnPropertySymbols, S = Object.getOwnPropertyDescriptor, b = Object.getPrototypeOf, T = Object.prototype;
  function R(y, g, p) {
    if (typeof g != "string") {
      if (T) {
        var c = b(g);
        c && c !== T && R(y, c, p);
      }
      var l = f(g);
      s && (l = l.concat(s(g)));
      for (var u = m(y), t = m(g), e = 0; e < l.length; ++e) {
        var o = l[e];
        if (!n[o] && !(p && p[o]) && !(t && t[o]) && !(u && u[o])) {
          var d = S(g, o);
          try {
            _(y, o, d);
          } catch {
          }
        }
      }
    }
    return y;
  }
  return x = R, x;
}
var X = Q();
const Z = /* @__PURE__ */ B(X);
function ee(r, a) {
  if (!r) {
    var n = new Error("loadable: " + a);
    throw n.framesToPop = 1, n.name = "Invariant Violation", n;
  }
}
var te = /* @__PURE__ */ E.createContext(), re = {
  initialChunks: {}
}, $ = "PENDING", ae = "RESOLVED", L = "REJECTED";
function ne(r) {
  return typeof r == "function" ? {
    requireAsync: r,
    resolve: function() {
    },
    chunkName: function() {
    }
  } : r;
}
var oe = function(a) {
  var n = function(h) {
    return E.createElement(te.Consumer, null, function(v) {
      return E.createElement(a, Object.assign({
        __chunkExtractor: v
      }, h));
    });
  };
  return a.displayName && (n.displayName = a.displayName + "WithChunkExtractor"), n;
}, ie = function(a) {
  return a;
};
function K(r) {
  var a = r.defaultResolveComponent, n = a === void 0 ? ie : a, i = r.render, h = r.onLoad;
  function v(_, f) {
    f === void 0 && (f = {});
    var s = ne(_), S = {};
    function b(c) {
      return f.cacheKey ? f.cacheKey(c) : s.resolve ? s.resolve(c) : "static";
    }
    function T(c, l, u) {
      var t = f.resolveComponent ? f.resolveComponent(c, l) : n(c);
      return Z(u, t, {
        preload: !0
      }), t;
    }
    var R = function(l) {
      var u = b(l), t = S[u];
      return (!t || t.status === L) && (t = s.requireAsync(l), t.status = $, S[u] = t, t.then(function() {
        t.status = ae;
      }, function(e) {
        console.error("loadable-components: failed to asynchronously load component", {
          fileName: s.resolve(l),
          chunkName: s.chunkName(l),
          error: e && e.message
        }), t.status = L;
      })), t;
    }, y = /* @__PURE__ */ function(c) {
      J(l, c), l.getDerivedStateFromProps = function(e, o) {
        var d = b(e);
        return P({}, o, {
          cacheKey: d,
          // change of a key triggers loading state automatically
          loading: o.loading || o.cacheKey !== d
        });
      };
      function l(t) {
        var e;
        return e = c.call(this, t) || this, e.state = {
          result: null,
          error: null,
          loading: !0,
          cacheKey: b(t)
        }, ee(!t.__chunkExtractor || s.requireSync, "SSR requires `@loadable/babel-plugin`, please install it"), t.__chunkExtractor ? f.ssr === !1 ? k(e) : (s.requireAsync(t).catch(function() {
          return null;
        }), e.loadSync(), t.__chunkExtractor.addChunk(s.chunkName(t)), k(e)) : (f.ssr !== !1 && // is ready - was loaded in this session
        (s.isReady && s.isReady(t) || // is ready - was loaded during SSR process
        s.chunkName && re.initialChunks[s.chunkName(t)]) && e.loadSync(), e);
      }
      var u = l.prototype;
      return u.componentDidMount = function() {
        this.mounted = !0;
        var e = this.getCache();
        e && e.status === L && this.setCache(), this.state.loading && this.loadAsync();
      }, u.componentDidUpdate = function(e, o) {
        o.cacheKey !== this.state.cacheKey && this.loadAsync();
      }, u.componentWillUnmount = function() {
        this.mounted = !1;
      }, u.safeSetState = function(e, o) {
        this.mounted && this.setState(e, o);
      }, u.getCacheKey = function() {
        return b(this.props);
      }, u.getCache = function() {
        return S[this.getCacheKey()];
      }, u.setCache = function(e) {
        e === void 0 && (e = void 0), S[this.getCacheKey()] = e;
      }, u.triggerOnLoad = function() {
        var e = this;
        h && setTimeout(function() {
          h(e.state.result, e.props);
        });
      }, u.loadSync = function() {
        if (this.state.loading)
          try {
            var e = s.requireSync(this.props), o = T(e, this.props, p);
            this.state.result = o, this.state.loading = !1;
          } catch (d) {
            console.error("loadable-components: failed to synchronously load component, which expected to be available", {
              fileName: s.resolve(this.props),
              chunkName: s.chunkName(this.props),
              error: d && d.message
            }), this.state.error = d;
          }
      }, u.loadAsync = function() {
        var e = this, o = this.resolveAsync();
        return o.then(function(d) {
          var w = T(d, e.props, p);
          e.safeSetState({
            result: w,
            loading: !1
          }, function() {
            return e.triggerOnLoad();
          });
        }).catch(function(d) {
          return e.safeSetState({
            error: d,
            loading: !1
          });
        }), o;
      }, u.resolveAsync = function() {
        var e = this.props;
        e.__chunkExtractor, e.forwardedRef;
        var o = D(e, ["__chunkExtractor", "forwardedRef"]);
        return R(o);
      }, u.render = function() {
        var e = this.props, o = e.forwardedRef, d = e.fallback;
        e.__chunkExtractor;
        var w = D(e, ["forwardedRef", "fallback", "__chunkExtractor"]), N = this.state, O = N.error, z = N.loading, U = N.result;
        if (f.suspense) {
          var M = this.getCache() || this.loadAsync();
          if (M.status === $)
            throw this.loadAsync();
        }
        if (O)
          throw O;
        var A = d || f.fallback || null;
        return z ? A : i({
          fallback: A,
          result: U,
          options: f,
          props: P({}, w, {
            ref: o
          })
        });
      }, l;
    }(E.Component), g = oe(y), p = E.forwardRef(function(c, l) {
      return E.createElement(g, Object.assign({
        forwardedRef: l
      }, c));
    });
    return p.displayName = "Loadable", p.preload = function(c) {
      p.load(c);
    }, p.load = function(c) {
      return R(c);
    }, p;
  }
  function m(_, f) {
    return v(_, P({}, f, {
      suspense: !0
    }));
  }
  return {
    loadable: v,
    lazy: m
  };
}
function ue(r) {
  return r.__esModule ? r.default : r.default || r;
}
var q = /* @__PURE__ */ K({
  defaultResolveComponent: ue,
  render: function(a) {
    var n = a.result, i = a.props;
    return E.createElement(n, i);
  }
}), ce = q.loadable, se = q.lazy, F = /* @__PURE__ */ K({
  onLoad: function(a, n) {
    a && n.forwardedRef && (typeof n.forwardedRef == "function" ? n.forwardedRef(a) : n.forwardedRef.current = a);
  },
  render: function(a) {
    var n = a.result, i = a.props;
    return i.children ? i.children(n) : null;
  }
}), le = F.loadable, fe = F.lazy, W = ce;
W.lib = le;
var de = se;
de.lib = fe;
var C = {}, I;
function he() {
  if (I) return C;
  I = 1;
  var r;
  return C.timeout = function(a, n) {
    var i = new r(), h;
    return Promise.race([
      a,
      new Promise(function(v, m) {
        h = setTimeout(function() {
          m(i);
        }, n);
      })
    ]).then(function(v) {
      return clearTimeout(h), v;
    }, function(v) {
      throw clearTimeout(h), v;
    });
  }, r = C.TimeoutError = function() {
    Error.call(this), this.stack = Error().stack, this.message = "Timeout";
  }, r.prototype = Object.create(Error.prototype), r.prototype.name = "TimeoutError", C;
}
var ve = he();
const me = ({ Component: r, delay: a }) => {
  const [n, i] = V(!1);
  return G(() => {
    const h = setTimeout(() => i(!0), a);
    return () => {
      clearTimeout(h);
    };
  }), n ? r : null;
}, be = ({ loader: r, loadingIndicator: a = null, timeoutThreshold: n = 3e4, minDelay: i = 200 }) => W(async () => {
  try {
    return await ve.timeout(r(), n);
  } catch (m) {
    throw m instanceof Error && m.message.includes("Failed to fetch dynamically imported module") && window.location.replace(window.location.href), m;
  }
}, {
  fallback: /* @__PURE__ */ H.jsx(me, {
    Component: a,
    delay: i
  })
});
export {
  me as LoadingIndicatorWithDelay,
  be as default
};
